import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-el-one",
  "use": "icon-el-one-usage",
  "viewBox": "0 0 128 128",
  "content": "<symbol viewBox=\"0 0 128 128\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-el-one\">\n<rect x=\"40\" y=\"13.5\" width=\"48\" height=\"100\" rx=\"10\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol